/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentFilter {
    getFixupPrototypeFunction() { return AssessmentFilter.fixupPrototype; }

    static newInstance(model: Partial<AssessmentFilter>): AssessmentFilter {
        let obj = Object.assign(new AssessmentFilter(), model);
        AssessmentFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentFilter>): AssessmentFilter {
        if (!model) return null;
        return AssessmentFilter.newInstance(<AssessmentFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentFilter) {
        if (!obj) return;

        models.AssessmentFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentFilter): boolean {
        Object.setPrototypeOf(obj, AssessmentFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Tenant id
     */
    tenant_id: string;

    query: models.QueryOperator;

}
